import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-right, margin, padding"><path d="M3.75 3.75L16.25 3.75L16.25 20.25H3.75L3.75 3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M20.25 3V21" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconLayoutRight;
